import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import { addTestAutomationClassName } from 'utils/misc'

import TransitionPage from 'containers/TransitionPage'
import ArrowButton from 'components/atoms/buttons/ArrowButton'
import OrganisationList from 'components/molecules/OrganisationList'

export const styles = theme => ({
  root: {
    width: 328,
    margin: '0 auto',
    animation: 'fadeIn .3s ease',
    ...theme.components.accountPage,
  },
  organisations: {
    margin: `${theme.spacing(2)}px 0`,
  },
  options: {
    marginTop: theme.spacing(2),
  },
  subtitle: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
  logoutLabel: {
    color: theme.palette.error.main,
  },
})

const AccountHome = ({
  classes,
  username,
  organisations,
  onLogoutPress,
  onOrganisationPress,
  onCreateOrganisationPress,
  onMenuPress,
}) => (
  <TransitionPage>
    <div className={classes.root}>
      <Typography variant="h1">
          Kia ora,
        <br />
        {username}
      </Typography>
      <OrganisationList
        data={organisations}
        onItemPress={onOrganisationPress}
        onCreatePress={onCreateOrganisationPress}
      />
      <section className={classes.options}>
        <ArrowButton
          onPress={onMenuPress}
          link="/account/edit-details"
          label="Edit profile"
          underline
          className={addTestAutomationClassName('qa-accounthome-link-editprofile')}
        />
        <ArrowButton
          onPress={onMenuPress}
          link="/account/change-password"
          label="Change password"
          underline
          className={addTestAutomationClassName('qa-accounthome-link-changepassword')}
        />
        <ArrowButton
          hideArrow
          label="Logout"
          onPress={onLogoutPress}
          link="/account/change-password"
          classes={{
            label: classes.logoutLabel,
          }}
          className={addTestAutomationClassName('qa-accounthome-link-logout')}
        />
        {/* <ArrowButton onPress={onMenuPress} link="/account/email-notifications" label="Email notifications" /> */}
      </section>
    </div>
  </TransitionPage>
)

AccountHome.propTypes = {
  username: PropTypes.string,
  onMenuPress: PropTypes.func,
  onLogoutPress: PropTypes.func,
  organisations: PropTypes.object,
  onOrganisationPress: PropTypes.func,
  classes: PropTypes.object.isRequired,
  onCreateOrganisationPress: PropTypes.func,
}

export default withStyles(styles)(AccountHome)



// WEBPACK FOOTER //
// ./src/containers/account/AccountHome/AccountHome.js